export enum CalAttendeeRole {
    PREPARER = 'PREPARER', // not support
    OBSERVER = 'OBSERVER',
    CHAIRMAN = 'CHAIRMAN',
    MEMBER = 'MEMBER',
    CREATOR = 'CREATOR'
}
